import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const agencyProfileReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_REQUEST:
      return {...state,
        isFetching: true,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SUCCESS:
      return {...state,
        isFetching: false,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_FAILURE:
    case Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_AGENCY_FEE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_SETTINGS_AGENCY_PROFILE_CLEAR:
    case Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_CLEAR:
    case Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
